<template>
  <div
    class="list-item-hover d-flex align-center pa-3 grey lighten-4 mb-2"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <div class="file py-2 mr-2 text-body-2 font-weight-medium">
      {{ file.name }}
    </div>
    <v-spacer />
    <div class="d-flex justify-end align-center">
      <v-progress-circular
        v-if="state === 'IN_PROGRESS'"
        class="mr-1"
        background-color="#cccccc"
        color="primary"
        size="20"
        width="2"
        :value="progress"
        rounded
        rotate="270"
      />
      <v-icon v-else-if="state === 'COMPLETE'" color="success">
        check_circle
      </v-icon>
      <span v-else-if="state === 'ERROR'" class="error--text">
        {{ error }}
      </span>
      <template v-else>
        <div v-if="state !== 'HOVER'">
          <div class="caption grey--text text--darken-2">
            File Source
          </div>
          <file-source-controls
            v-model="source"
            class="mr-2"
            @input="onSetSource"
          />
        </div>
        <div v-if="state !== 'HOVER'">
          <div class="caption grey--text text--darken-2">
            Pre-screen
          </div>
          <assessment-dropdown
            v-model="label"
            show-outcome-icons
            :show-label="false"
            :hide-options="['NOT_SURE']"
            @input="onSetLabel"
          />
        </div>
        <v-btn class="ml-2" icon small @click="$emit('cancel')">
          <v-icon color="error">remove_circle</v-icon>
        </v-btn>
      </template>
    </div>
  </div>
</template>

<script>
import FileSourceControls from '@/components/UploadReferences/FileSourceControls.vue';
import AssessmentDropdown from '@/components/References/AssessmentDropdown';
import { RelevanceAssessment, FileSource } from '@/enums';

export default {
  name: 'ReferenceUploadListItem',
  components: { FileSourceControls, AssessmentDropdown },
  props: {
    file: {
      type: [File, Object],
      default: null,
    },
    progress: {
      type: [String, Number],
      default: '50',
    },
    showCancel: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    hover: false,
    label: RelevanceAssessment.UNSCREENED,
    source: FileSource.DATABASE,
  }),
  computed: {
    state() {
      if (this.showCancel) {
        return 'SHOW_CANCEL';
      }
      const progress = parseInt(`${this.progress}`);
      if (this.hasError) {
        return 'ERROR';
      } else if (progress < 100) {
        if (this.hover) {
          return 'HOVER';
        }
        return 'IN_PROGRESS';
      } else {
        return 'COMPLETE';
      }
    },
    hasError() {
      return !!this.error && this.error.trim().length > 0;
    },
  },
  mounted() {
    this.onSetSource(this.source);
  },
  methods: {
    onSetLabel(event) {
      this.$emit(
        'set-label',
        event !== RelevanceAssessment.UNSCREENED ? event : null
      );
    },
    onSetSource(source) {
      this.$emit('set-source', source);
    },
  },
};
</script>

<style scoped>
.file {
  overflow-wrap: anywhere;
}
</style>
